/**
 * @brief   Singleton de AppAjax.
 * @see     resources/js/scripts/functions/AppAjax.class.js
 */


/*
|--------------------------------------------------------------------------
| DEBUT DU FICHIER - NE RIEN AJOUTER D'AUTRE QUE require() AU DESSUS !
|--------------------------------------------------------------------------
*/

/**
 * @brief   Fonctionnalités de la page de reinitialisation de mot de passe'
 */
jQuery(document).ready(function() {
	
	$('#submitBtn').click(function(){
		let nPwd = $('input[name=newPwd]').val() ?? null
		let cPwd = $('input[name=pwdConfirmation]').val() ?? null
	
		if(nPwd && cPwd ) {
			if(nPwd === cPwd) {
			$('#confirmationError').css('display','none')
			$('#resetForm').submit()
			} else {
			$('#confirmationError').css('display','block')
			}
		} 	
	})
});
/*
|--------------------------------------------------------------------------
| FIN DU FICHIER - NE RIEN AJOUTER EN DESSOUS !
|--------------------------------------------------------------------------
*/
